import React from 'react'
// import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'

import Button from '../../components/common/button'

import * as actions from './actions'

import { amountFormatting } from '../../utils'
import { routePrefix } from '../../config'

import RupeeIcon from '../../images/rupee.svg'
import './styles.css'

const actionButtonStyle = { width: 80, height: 30, padding: 0, marginLeft: 5 }

class CancellationOffersList extends React.Component {
  
  state = {}

  componentDidMount() {
    this.date = moment().format('DD-MMM-YYYY');
    this.props.getOperatorRoutes();
    this.props.getCancellatinOffers();
  }

  onEditOfferClick = (id, paytmRoute) => {
    this.props.history.push(routePrefix + '/cancellation-offer/edit/' + id + '/' + paytmRoute);
  }

  onDisableOfferClick = (offer) => {
    this.props.updateOfferStatus(
      {
        paytm_route: offer.paytm_route,
        policy_id: offer.policy_id
      },
      {
        is_active: !offer.is_active
      },
      () => this.props.getCancellatinOffers()
    );
  }

  onDeleteOfferClick = () => {}

  render() {
    const { cancellationOffersList, paytmCitiesMap } = this.props;
    return (
      <div className="payout">
        <div className="cancellation-header">
          <div>
            <p className="payout-header-text">Free Cancellation Offers</p>
            <p className="payout-updated-date">{this.date}</p>
          </div>
          <div className="create-deal-button">
            <Link to={routePrefix + '/cancellation-offer/create'}>
              <Button styleObj={{ width: 200 }} label="Create Offer" onButtonClick={null} />
            </Link>
          </div>
        </div>
        <div className="payout-content">
          <table className="payout-table">
            <thead>
              <tr className="payout-table-header">
                <th>Source</th>
                <th>Destination</th>
                {/*<th>Service</th>*/}
                <th>Valid Till</th>
                <th>Time Window</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                !cancellationOffersList.length && <tr><td colSpan={7} className="table-no-data">No Data Found</td></tr>
              }
              {
                cancellationOffersList.map((el, i) => (
                  <tr key={el.policy_id} className="payout-table-row">
                    <td>{paytmCitiesMap[el.sourceId] || '-'}</td>
                    <td>{paytmCitiesMap[el.destId] || '-'}</td>
                    <td>{el.end_date}</td>
                    <td>{el.timeWindow}</td>
                    <td>{el.is_active? "Active": "Expired"}</td>
                    <td>
                      <Button styleObj={actionButtonStyle} label="Edit" onButtonClick={this.onEditOfferClick.bind(this, el.policy_id, el.paytm_route)} />
                      <Button styleObj={actionButtonStyle} label={el.is_active ? "Disable" : "Enable"} onButtonClick={this.onDisableOfferClick.bind(this, el)} />
                      {/*<Button styleObj={actionButtonStyle} label="Delete" onButtonClick={this.onDeleteOfferClick.bind(this, el)} />*/}
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

const mapStateToProps = store => ({
  paytmCitiesMap: store.cancellationOffers.paytmCitiesMap || {},
  cancellationOffersList: store.cancellationOffers.cancellationOffersList
})

const mapDispatchToProps = dispatch => ({
  getCancellatinOffers: () => dispatch(actions.getCancellatinOffers()),
  getOperatorRoutes: () => dispatch(actions.getOperatorRoutes()),
  updateOfferStatus: (data, payload, callback) => dispatch(actions.updateOfferStatus(data, payload, callback))
})

CancellationOffersList.propTypes = {}

export default connect(mapStateToProps, mapDispatchToProps)(CancellationOffersList)
